//Components
import { NotificationManager } from 'Components/Notifications';

/**
 * Validate if a given date is overlapping another inside the dates array.
 * @param {String} dayToValidate - Date to validate
 * @param {Array} arrayDays - Days array to search for.
 */
export const isOverlapped = (dayToValidate, arrayDays) => {
  // Gets the same days  to compare the date to validate.
  const givenDays = arrayDays?.filter((givenDay) => givenDay.day === dayToValidate.day);
  const { timeFrom, timeTo } = dayToValidate;

  const { startHour, endHour } = getStartAndEndHours(timeFrom, timeTo);
  const rangeToVerify = getRange(startHour, endHour);

  const givenDaysRanges = givenDays.map((givenDay) => {
    const { timeFrom, timeTo } = givenDay;
    const { startHour, endHour } = getStartAndEndHours(timeFrom, timeTo);

    return getRange(startHour, endHour);
  });

  let counter = 0;
  givenDaysRanges.forEach((givenRange) => {
    givenRange.forEach((hour) => {
      if (rangeToVerify.includes(hour)) {
        counter++;
      }
    });
  });

  return counter > rangeToVerify.length + 1;
};

/**
 * Gets an initial number and a final number and builds an array filling the
 * middle numbers.
 * @param {number} startHour - Number to start the time range.
 * @param {number} endHour - Number to end the time range.
 * @returns {Array[numbers]} - for the input (2,5) returns [2,3,4,5].
 */
export const getRange = (startHour, endHour) => {
  let range = [];
  const performedEndHour = endHour || 24;

  for (let index = startHour; index <= performedEndHour; index++) {
    range.push(index);
  }

  return range;
}

/**
 * Gets two dates and returns an object with the hours of each date.
 * @param {Date} initDate - First date to get the hour.
 * @param {Date} EndDate - Second date to get the hour.
 * @returns {{number, number}} - An object with the hour of each given date.
 */
export const getStartAndEndHours = (initDate, EndDate) => {
  const startHour = initDate?.getHours();
  const endHour = EndDate?.getHours();

  return { startHour, endHour };
}

/**
 * Validates if the alert has at least an assigned unit.
 * @param {number} tabNumber - The current tab number
 * @param {string} alertType - The alert type.
 * @param {Array} entityArray - The current assigned entity
 * @param {string} errorMessageKey - The internacianization key for the error message
 * @param {Object} messages - The internacionalization messages object.
 * @returns {boolean} - true if it's a valid assignment, false otherwise.
 */
export const unitsValidation = (tabNumber, alertType, entityArray, errorMessageKey, messages) => {
  const alertFinalTab = {
    OffHour: 3,
  };
  const finalTab = alertFinalTab[alertType] || 2;

  if(tabNumber === finalTab && !entityArray.length) {
    return showNotification(errorMessageKey, messages);
  }

  return true;
}

/**
 * Shows a toast notification.
 * @param {string} messageKey - The internacianization key for the message.
 * @param {Object} messages - The internacionalization messages object.
 * @returns {boolean} - false if the message is showed.
 */
export const isVidFleet = (name) => name?.toUpperCase() === 'VIDFLEET'

// videoDevices keeps the VidFleet manufacturer after linkedUnit is cleared.
export const unitHasVidFleetCamera = (unit) =>
  isVidFleet(unit?.manufacturerName)
  || isVidFleet(unit?.linkedUnit?.manufacturerName)
  || unit?.videoDevices?.some((device) => isVidFleet(device?.manufacturer) || isVidFleet(device?.manufacturerName))

export const showNotification = (messageKey, messages) => {
  NotificationManager
    .warning(messages[messageKey], messages['wait'], 3000, null, null, 'warning', null);

  return false;
};